import { type PurchasePlanSettings } from '@components/PricingPlans';
import { useQuery } from '@tanstack/react-query';
import { getUserPlanSettings } from '@services/youtube-platform.service';

export const usePurchasePlan = (billingAccountOwnerID: string) => {
  const { data: userPlan } = useQuery({
    queryKey: ['purchase-plan', billingAccountOwnerID],
    queryFn: () => getUserPlanSettings(billingAccountOwnerID),
    enabled: () => {
      if (!billingAccountOwnerID) return false;
      return true;
    }
  });

  const newPlans = [
    'Starter-Monthly',
    'Starter-Yearly',
    'Pro-Monthly',
    'Pro-Yearly',
    'Enterprise',
  ];

  const name = (userPlan?.entity?.name || '') as string;
  const isFreePlan = name === 'Free Plan';
  const isOldPlan = !isFreePlan && !newPlans.includes(name);

  return {
    isOldPlan,
    isFreePlan,
    name,
    settings: (userPlan?.entity?.settings || {}) as PurchasePlanSettings
  };
};
